import { a as X, p as Z, $ as q, q as G, r as j } from "../../../vendor-Dd6qj6gJ.js";
import { useRef as d, useState as J, useCallback as u } from "react";
const Q = 16, z = 64, W = 480;
function et({
  width: R,
  defaultWidth: D,
  minWidth: e,
  maxWidth: v,
  placement: o,
  onResize: y,
  onResizeEnd: c,
  dialogId: T
}) {
  const [l, g] = X(
    R,
    D ?? W,
    void 0
    // we call onResize/onResizeEnd explicitly, not via this hook
  ), E = typeof l == "number" ? `${l}px` : l, i = d(0), I = d(""), [b, h] = J(null), w = d(null), x = d(null), S = d(null), n = u(() => {
    const t = typeof window < "u" ? Math.round(window.innerWidth * 0.92) : Number.POSITIVE_INFINITY;
    return Math.min(v ?? Number.POSITIVE_INFINITY, t);
  }, [v]), p = u(
    (t) => Math.round(Math.min(Math.max(t, e), n())),
    [e, n]
  ), _ = u(
    (t) => {
      const r = n() - e, s = r > 0 ? Math.round((t - e) / r * 100) : 0;
      return o === "right" ? 100 - s : s;
    },
    [e, o, n]
  ), $ = u(
    (t) => {
      const r = o === "right" ? 100 - t : t;
      return Math.round(e + r / 100 * (n() - e));
    },
    [e, o, n]
  ), K = u((t) => {
    w.current = t, t !== null && h(Math.round(t.getBoundingClientRect().width));
  }, []), { isFocusVisible: M, focusProps: N } = Z(), { visuallyHiddenProps: P } = q(), f = u(
    (t) => {
      const r = p(t);
      i.current = r, h(r), g(r), y?.(r);
    },
    [p, y, g]
  ), { moveProps: V } = G({
    onMoveStart: (t) => {
      if (t.pointerType === "keyboard")
        return;
      const r = w.current;
      r !== null && (i.current = r.getBoundingClientRect().width, x.current?.setAttribute("data-resizing", "true"), I.current = document.body.style.userSelect, document.body.style.userSelect = "none");
    },
    onMove: (t) => {
      if (t.pointerType === "keyboard" || w.current === null)
        return;
      const r = o === "left" ? t.deltaX : -t.deltaX, s = p(i.current + r);
      s !== i.current && (i.current = s, h(s), g(s), y?.(s));
    },
    onMoveEnd: (t) => {
      t.pointerType !== "keyboard" && (x.current?.removeAttribute("data-resizing"), document.body.style.userSelect = I.current, c?.(i.current));
    }
  }), C = u(
    (t) => {
      const r = $(Number(t.target.value));
      f(r), c?.(r);
    },
    [f, $, c]
  ), L = u(
    (t) => {
      const r = t.key === "ArrowLeft" || t.key === "ArrowRight", s = t.key === "Home" || t.key === "End";
      if ((r || s) && t.stopPropagation(), t.key === "Escape") {
        t.target.blur();
        return;
      }
      if (t.key === "Home") {
        t.preventDefault();
        const a = o === "right" ? n() : e;
        f(a), c?.(a);
      } else if (t.key === "End") {
        t.preventDefault();
        const a = o === "right" ? e : n();
        f(a), c?.(a);
      } else if (t.shiftKey && (t.key === "ArrowLeft" || t.key === "ArrowRight")) {
        t.preventDefault();
        const a = t.key === "ArrowRight" ? 1 : -1, U = o === "right" ? -a : a, Y = i.current || (b ?? e), A = p(Y + U * z);
        f(A), c?.(A);
      }
    },
    [p, f, b, e, c, o, n]
  ), m = u((t) => {
    (t.key === "ArrowLeft" || t.key === "ArrowRight") && t.stopPropagation();
  }, []), k = typeof l == "number" ? Math.round(l) : b ?? e, B = _(k), F = Math.max(
    1,
    Math.round(Q / Math.max(n() - e, 1) * 100)
  ), H = {
    ref: x,
    "data-placement": o,
    "data-focus-visible": M || void 0,
    ...V,
    tabIndex: -1
  }, O = {
    ref: S,
    ...j(P, N),
    type: "range",
    "aria-label": "Resize drawer",
    "aria-orientation": "horizontal",
    "aria-controls": T,
    "aria-valuetext": `${k} pixels`,
    min: 0,
    max: 100,
    step: F,
    value: B,
    onChange: C,
    onKeyDown: L,
    onKeyUp: m,
    style: {
      ...P.style,
      touchAction: "none",
      outline: "none"
    }
  };
  return {
    /** CSS value for --drawer-width (e.g. "480px"). */
    widthValue: E,
    /** Ref callback for the modal/drawer node. */
    setDrawerRef: K,
    /** Whether the keyboard focus ring is visible. */
    isFocusVisible: M,
    /** Spread onto the outer resizer <div>. */
    resizerProps: H,
    /** Spread onto the visually-hidden <input type="range">. */
    inputProps: O
  };
}
export {
  Q as KEYBOARD_RESIZE_STEP,
  z as KEYBOARD_RESIZE_STEP_LARGE,
  et as useDrawerResize
};
